module.exports = __webpack_public_path__ + "static/media/image-2.b06a0e25.png";